import { useWizard } from "react-use-wizard";
import React from "react";
import NavigateBack from "../../components/navigateBack";
import Gender from "../../components/gender";

function GenderStep({ qKey, question, onSubmitHandler, state }) {
  const { previousStep, nextStep } = useWizard();
  const _qKey = qKey;

  const onNextFn = (data) => {
    onSubmitHandler({ [_qKey]: data });
    nextStep();
  };

  return (
    <>
      <NavigateBack onClickHandler={previousStep} />
      <Gender
        question={question}
        onSubmitHandler={onNextFn}
        selectedGender={state}
      />
    </>
  );
}

export default GenderStep;
